import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponenRegistryService } from 'src/app/core/services/component-registry.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { GlobalVariableService } from '../../../../core/services/global-variable.service';
import { LocalStorageService } from 'ngx-webstorage';
import { SharedDataService } from '../../../../core/services/shared-data.service';
import { forkJoin } from 'rxjs';
import {AppConfigService} from "../../../../core/services/config.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit, OnDestroy {
    public sideBar: any;
    public quickSidebar: any;
    private _unsubscribeAll: Subject<any>;
    public nameUserConnected: string;
    public emailUserConnected: string;
    public listCampagne: any;
    public listOFA: any;
    public old_password: string;
    public new_password: string;
    public c_new_password: string;
    public response: any;
    public fiche: any;
    public typeView: string;
    public API_URL: any;
    public user: any;
    public ifurl: any;
    public dataLoaded: boolean = false;
    public campagneOFA;
    public ENVIRONNEMENT: any;
    constructor(
        private _componenRegistryService: ComponenRegistryService,
        private toastrService: ToastrService,
        private _loader: LoadingBarService,
        private _router: Router,
        private storage: LocalStorageService,
        private _service: AppService,
        private activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private variable: GlobalVariableService,
        public configService: AppConfigService,
        private sharedService: SharedDataService,
    ) {
        this._unsubscribeAll = new Subject();
        this.API_URL = configService.get('HOST_API_ONLINE');
        this.ENVIRONNEMENT = configService.get('HOST_ENVIRONMENT');
    }
    public ngOnInit() {
        this.ifurl = localStorage.getItem('seturl');
        this.getCampagneActive();
       this._componenRegistryService.onRegistryChanged
           .pipe(takeUntil(this._unsubscribeAll))
           .subscribe(registry => {
               this.sideBar = this._componenRegistryService.getComponent('sidenav');
               this.quickSidebar = this._componenRegistryService.getComponent('quick-sidebar');
           });


        // get UserData
        this.user = JSON.parse(this.variable.getUser());
        this.nameUserConnected = this.user?.nom + ' ' + this.user?.prenoms;
        this.emailUserConnected = this.user?.email;
    }

    public toggleSidebar(event): void {
        event.preventDefault();
        this.sideBar.sidebarToggleHandler();
    }

    public toggleQuickSidebar(event): void {
        event.preventDefault();
        this.quickSidebar.toggleOpen();
    }

    public ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    // Call both services simultaneously
    public getCampagneActive() {
 if (!this.dataLoaded) {
        forkJoin([
            this._service.postData('gestion-campagnes/eia/all-campagnes-active', {}),
            this._service.getData('gestion-ofas/campagnes/ofa/all')
        ]).subscribe(([eiaCampagnes, ofaCampagnes]) => {
            // Handle EIA campagnes response
            if (eiaCampagnes.error === false) {
                this.listCampagne = eiaCampagnes.data;
                const lastEia: any = this.listCampagne[0];
                this.storage.store('idCampagneEiaSelected', lastEia.id);
                if (this.user?.profil?.slug !== 'administrateur') {
                  this.getIdFiche(lastEia.id);
                }
                this.storage.store('lastCampagne', lastEia);
            } else {
                console.log(eiaCampagnes.message);
            }

            // Handle OFA campagnes response
            if (ofaCampagnes.error === false) {
                this.listOFA = ofaCampagnes.data;
                const lastOfa: any = this.listOFA[this.listOFA.length - 1];
                this.storage.store('idCampagneOfaSelected', lastOfa?.id);
                if (!this.campagneOFA) {
                    this.campagneOFA = this.listOFA.find(element => element.id == lastOfa.id);
                    localStorage.setItem('year', JSON.stringify(this.campagneOFA));
                }
            }
        });
        }
    }

    public getUserInitials(fullName: string): string {
      if (!fullName) return '';

      const nameParts = fullName.split(' ');
      const initials = nameParts.length > 1
        ? nameParts[0][0] + nameParts[1][0]
        : nameParts[0][0];

      return initials.toUpperCase();
    }

    public onSelectCampagneOFA(id):void {
        this.storage.store('idCampagneOfaSelected', id);
        localStorage.removeItem('year');
        this.campagneOFA = this.listOFA.find(element => element.id == id);
        localStorage.setItem('year', JSON.stringify(this.campagneOFA));
        this.sharedService.sendRefreshAnnee();
    }

    onSelectCampagneEIA(id) {
        let isresponsable = this.storage.retrieve('isresponsable');
        let withN1 = localStorage.getItem('n-1');
        this.storage.store('idCampagneEiaSelected', id);
        sessionStorage.setItem('idCampagneSelected', id);
        if (this.user.profil?.slug === 'pvch-eia' || this.user.profil?.slug === 'pvch-exceptionnel' || this.user.profil?.slug === 'pvch-exceptionnel') {
            this._router.navigate(['/campagne/initialisation-eia']);
            this.toastrService.success('Cliquer sur le bouton Rafraichir de votre tableau');
        } else if (this.user.profil?.slug === 'agent' && isresponsable && withN1 === 'not-exist') {
            this._router.navigate(['/structure/campagne-eia']);
            this.getIdFiche(id);
            this.toastrService.success('Cliquer sur le bouton Rafraichir de votre tableau');
        } else if (this.user.profil?.slug === 'agent' && !isresponsable && withN1 === 'exist') {
            this._router.navigate(['/evaluation/moi']);
            this.getIdFiche(id);
            this.toastrService.success('Cliquer sur le bouton Rafraichir de votre tableau');
        } else if (this.user.profil?.slug === 'agent' && !isresponsable && withN1 === 'not-exist') {
            this._router.navigate(['/evaluation/moi']);
            this.getIdFiche(id);
            this.toastrService.success('Cliquer sur le bouton Rafraichir de votre tableau');
        } else {
            this._router.navigate(['/dashboard']);
            this.getIdFiche(id);
        }
    }

    public editPassword(content) {
        this.activeModal = this.modalService.
            open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
    }

    public goToEspaceDigital() {
        if (this.user?.profil?.slug === 'agent' || this.user?.profil?.slug === 'directeur' || this.user?.profil?.slug === 'responsable-structure') {
            this._router.navigate(['/home']);
        } else {
            this._router.navigate(['/desk']);
        }
    }

    public changePassword() {
        this._loader.start();
        const data = {
            'old_password': this.old_password,
            'new_password': this.new_password,
            'c_new_password': this.c_new_password
        }
        this._service.updateData('user/changepassword', data)
            .subscribe(
                res => {
                    if (res.error === false) {
                        this.activeModal.close();
                        swal.fire({
                            title: 'HR PERF',
                            type: 'success',
                            text: res.message,
                            showCancelButton: false,
                            confirmButtonText: 'ok'
                        }).then(() => {
                            this._router.navigateByUrl('/login');
                            sessionStorage.clear();
                        })
                        this._loader.stop();
                    }
                    else {
                        swal.fire({
                            title: 'HR PERF',
                            type: 'error',
                            text: res.message,
                            showCancelButton: false,
                            confirmButtonText: 'ok',
                        });
                        this._loader.stop();
                    }
                },
                (err) => {
                    this.toastrService.error(err.error.message);
                    this._loader.stop();
                }
            );
    }

    public getIdFiche(id) {
        this._service.getData(`gestion-evaluations/fiche/${id}/get-fiche`)
            .subscribe(
                res => {
                    if (res.error === false) {
                        this.fiche = res?.data ?? "{}"
                        this.storage.store('idAgent', this.fiche?.entretien_id);
                    }
                }, err => {
                    // this.toastrService.error(err.error.message);
                }
            );
    }

    public logout() {
        this._router.navigate(['/login']);
    }

}
